<div *adaptLoadingUntilFirstEmit="let locations of locations$"
     class="d-flex flex-column gap-3">
    <ng-container *adaptLoadingUntilFirstEmit="let zones of zones$">
        @if (zones.length > 0) {
            <div class="d-flex flex-column gap-1">
                @for (zone of zones; track $index) {
                    <adapt-zone-label [zone]="zone"></adapt-zone-label>
                }
            </div>
        }
    </ng-container>
    @if (hasTier1Read$ | async) {
        <ng-container *adaptLoadingUntilFirstEmit="let keyFunctions of keyFunctions$">
            @if (keyFunctions.length > 0) {
                <div class="d-flex flex-column gap-1">
                    <div *ngFor="let kf of keyFunctions">
                        <adapt-link-key-function [keyFunction]="kf"></adapt-link-key-function>
                    </div>
                </div>
            }
        </ng-container>
    }
    <div *ngIf="locations.length === 0">
        This team (or any of its parent teams) has not been placed into a Zone
        @if (hasTier1Read$ | async) {
            or Key Function
        }
    </div>
</div>
